module.exports = __webpack_public_path__ + "static/text-2-d75e5135be5312f5233f46eb0f914d2b.svg";